import { Form, Formik } from 'formik';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { useEffect, useRef, useState } from 'react';
import { msgTypes } from 'constants/msgTypes';
import { FinancialProtectionSchema } from 'schemas/menu/financialProtection/FinancialProtectionSchema';
import { FinancialProtectionMessageModel } from 'model/screensModels/FinancialProtectionMessageModel';
import { FinancialProtectionMessageService } from 'services/menu/financialProtectionMessage/FinancialProtectionMessageService';
import { FinancialProtectionMessageSchema } from 'schemas/menu/financialProtectionMessage/FinancialProtectionMessageSchema';

const CreateFinancialProtectionMessage = ({setFlag, updateRecord, loadRecentGuidelineMessage}) => {
    const [viewMode, setViewMode] = useState(false);
    const [initialValue, setInitialValue] = useState(new FinancialProtectionMessageModel());
    const formikRef = useRef(null);
    const fileInputRef = useRef(null);
  
    const onSubmit = async (values: FinancialProtectionMessageModel) => {
        addFinancialProtectionMessage(values)
    }
  
    useEffect(() => {
      if (updateRecord) {
        setInitialValue(updateRecord)
      }
    }, [updateRecord])
  
    //Prepare Data for API
    const prepareRequestBody = async (values: FinancialProtectionMessageModel) => {
      const prepareData = new FinancialProtectionMessageModel();
  
      //to assing id based on action
      if ((initialValue.financialProtectionMessageId)?.length > 0) {
        prepareData.financialProtectionMessageId = initialValue.financialProtectionMessageId;
      } else {
        prepareData.financialProtectionMessageId = values.financialProtectionMessageId ? values.financialProtectionMessageId : '';
      }
  
      prepareData.financialProtectionMessage = values.financialProtectionMessage ? values.financialProtectionMessage : '';
      prepareData.status = values.status ? values.status : false;
  
      return prepareData;
    }
  
    const addFinancialProtectionMessage = async (values: FinancialProtectionMessageModel) => {
      const requestData = await prepareRequestBody(values);
      const res = await FinancialProtectionMessageService.addFinancialProtectionMessage(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        setInitialValue(new FinancialProtectionMessageModel());
        loadRecentGuidelineMessage();
        formikRef.current.resetForm();
      }
    };



  return (
    <>
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={FinancialProtectionMessageSchema}
      onSubmit={onSubmit}
      innerRef={formikRef}
    >

      {
        ({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            <div className="container">
              <div className="row">
              
                <div className="col-lg-12 col-md-12 position-relative">
                  <FormikControl control='textfield'
                    name='financialProtectionMessage'
                    label="Financial Protection Message"
                    placeholder="Enter Financial Protection Guidelines"
                    requiredField
                    multiline
                    disabled={viewMode}
                    rows={10}
                    
                  />
                </div>
              
                {!viewMode ? (
                  <div className='col-12 d-flex justify-content-end'>
                    <FormikControl control='button' className="btn btn-submit" color="primary" label={values.financialProtectionMessageId ? 'Update' : 'Save'} disabled={!dirty || !isValid || isSubmitting} />&nbsp;&nbsp;
                    <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                  </div>
                ) : null}
              </div>
            </div>
          </Form>
        )
      }
    </Formik>
  </>
  )
}

export default CreateFinancialProtectionMessage